import { gql } from "@apollo/client";

const MyWorkHistoryItemFragment = gql`
  fragment MyWorkHistoryItemFragment on WorkHistorySummaryNode {
    id
    summary
    modifiedSummary
    managerHomepageSummary
    meetingCount
    meetingTimeHours
    created
    summaryStartDate
    summaryEndDate
    externalEventData
    externalEventDataSummaries
    subject {
      id
      name
      avatar
    }
    collaborators {
      edges {
        node {
          collaborationCount
          user {
            id
            name
            avatar
          }
        }
      }
    }
    sections {
      edges {
        node {
          id
          title
          modifiedTitle
          content
          modifiedContent
          hidden
        }
      }
    }
  }
`;

export default MyWorkHistoryItemFragment;
